import { render } from "./RequiredDocuments.vue?vue&type=template&id=b5c0fcda&scoped=true"
import script from "./RequiredDocuments.vue?vue&type=script&lang=js"
export * from "./RequiredDocuments.vue?vue&type=script&lang=js"

import "./RequiredDocuments.vue?vue&type=style&index=0&id=b5c0fcda&lang=scss&scoped=true"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c0fcda"]])

export default __exports__